import { toast } from "react-toastify";
import axios from "axios";
import { Annonce, AnnonceFinal } from "../models/AnnonceModel";

const API_URL = process.env.REACT_APP_API_URL;
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;

const token = localStorage.getItem("token");


const convertImageToBase64 = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

const applyPromoCode = async (promoCode: string, userId: string) => {
  try {
    await axios.post(
      `${API_URL}/promo-code/apply`,
      { code: promoCode, userId },
      {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
          'Content-Type': 'application/json',
        }
      }
    );
  } catch (error) {
    // Optionnel : gestion d’erreur (ex : toast ou log)
    console.error("Erreur lors de l'application du code promo :", error);
  }
};

export const createAnnonceTemp = async (data: any, imageFile: File | null) => {
  try {

    console.log("📝 CRÉATION ANNONCE TEMP:");
    // console.log("- Montant TTC annonce:", data.montantTTCannonce);
    // console.log("- Montant final TTC:", data.montantFinalTTC);
    // console.log("- Données complètes:", data);


    const userId = localStorage.getItem('userId');
    const jalNumber = Number(data.jal);
    const nJustif = data.nJustif;

    let enteteBase64: string | null = data.entete || '';
    if (imageFile) {
      enteteBase64 = await convertImageToBase64(imageFile);
    }

    const body = {
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      numdossier: "",
      numannonce: "",
      reference_client: data.reference_client,
      annonceur: data.denomination,
      annonce: data.annonce,
      departement: data.departement,
      jal: jalNumber,
      justif: nJustif,
      demande: data.demande,
      type: data.type,
      stype: data.stype,
      entete: enteteBase64,
      floid: data.floid,
      userId: userId,
      textAnnonce: data.textAnnonce,
      denomination: data.denomination,
      type_annonce: data.type_annonce,
      tv_intra: 0,
      paymentRef: data.paymentRef,
      postalCode: data.postalCode,
      montantHTannonce: data.montantHTannonce,
      montantTTCannonce: data.montantTTCannonce,
      montantFinalTTC: data.montantFinalTTC,
      PromoCodeId: data.PromoCodeId,
      commission_percentage: data.commission_percentage,
      city:data.city,
      usedPoints: data.usedPoints,
      creditNoteAmount: data.creditNoteAmount,
      legalMoTTC: data.legalMoTTC,

      discountPercentageAmount: data.discountPercentageAmount ?? 0,
      pointsDiscountAmount: data.pointsDiscountAmount ?? 0,
      creditNoteDiscountAmount: data.creditNoteDiscountAmount ?? 0,
      totalDiscountAmount: data.totalDiscountAmount ?? 0,
      
    };
    console.log("Body createAnnonceTemp", body);

    const response = await axios.post(`${API_URL}/annonce/creer-annonce-temp`, body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem("token")}`, 
      }
    });
    console.log("Pdflegalle", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error)) {
      console.error("Erreur lors de la création de l'annonce :", error.response?.data || error.message);
    } else {
      console.error("Erreur inconnue lors de la création de l'annonce :", error);
    }
    throw error;
  }
};

export const createAnnonceForBilling = async (data: any, imageFile: File | null) => {
  try {

    console.log("📝 CRÉATION ANNONCE TEMP:");
    console.log("- Montant TTC annonce:", data.montantTTCannonce);
    console.log("- Montant final TTC:", data.montantFinalTTC);
    console.log("- Données complètes:", data);


    const userId = localStorage.getItem('userId');
    const jalNumber = Number(data.jal);
    const nJustif = data.nJustif;

    let enteteBase64: string | null = data.entete || '';
    if (imageFile) {
      enteteBase64 = await convertImageToBase64(imageFile);
    }

    const body = {
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      numdossier: "",
      numannonce: "",
      reference_client: data.reference_client,
      annonceur: data.denomination,
      annonce: data.annonce,
      departement: data.departement,
      jal: jalNumber,
      justif: nJustif,
      demande: data.demande,
      type: data.type,
      stype: data.stype,
      entete: enteteBase64,
      floid: data.floid,
      userId: userId,
      textAnnonce: data.textAnnonce,
      denomination: data.denomination,
      type_annonce: data.type_annonce,
      tv_intra: 0,
      paymentRef: data.paymentRef,
      postalCode: data.postalCode,
      montantHTannonce: data.montantHTannonce,
      montantTTCannonce: data.montantTTCannonce,
      montantFinalTTC: data.montantFinalTTC,
      PromoCodeId: data.PromoCodeId,
      commission_percentage: data.commission_percentage,
      city:data.city,
      usedPoints: data.usedPoints,
      creditNoteAmount: data.creditNoteAmount,
      legalMoTTC: data.legalMoTTC,
      clientId: data.clientId,
      lienPaiement: data.lienPaiement
    };
    console.log("Body createAnnonceForBilling", body);

    const response = await axios.post(`${API_URL}/annonce/create-annonce-for-billing`, body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem("token")}`, 
      }
    });
    console.log("Pdflegalle", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error)) {
      console.error("Erreur lors de la création de l'annonce :", error.response?.data || error.message);
    } else {
      console.error("Erreur inconnue lors de la création de l'annonce :", error);
    }
    throw error;
  }
};

export const createFreeAnnouncement = async (data: any, imageFile: File | null) => {
  try {
    const userId = localStorage.getItem('userId');
    const departementNumber = Number(data.departement);
    const jalNumber = Number(data.jal);

    let enteteBase64: string | null = data.entete || '';
    if (imageFile) {
      enteteBase64 = await convertImageToBase64(imageFile);
    }

    const body = {
      shai: SHAI,
      codeClient: CODECLIENT,
      numdossier: "",
      numannonce: "",
      reference_client: data.reference_client,
      annonceur: data.annonceur || data.denomination,
      annonce: data.annonce,
      departement: departementNumber,
      jal: jalNumber,
      justif: data.nJustif,
      demande: data.demande,
      type: data.type,
      stype: data.stype,
      entete: enteteBase64,
      floid: data.floid,
      userId: userId,
      textAnnonce: data.textAnnonce,
      denomination: data.annonceur || data.denomination,
      type_annonce: data.type_annonce,
      tv_intra: 0,
      postalCode: data.postalCode,
      originalAnnonceId: data.originalAnnonceId,
      montantHTannonce: data.newDiscountedAmountHT,
      montantTTCannonce: data.newDiscountedAmountTTC,
      PromoCodeId: data.PromoCodeId
    };

    console.log("DEBUG denomination reçue:", body)


    const response = await axios.post(`${API_URL}/annonce/creer-annonce-gratuite`, body, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    console.log("Pdflegalle", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (axios.isAxiosError(error)) {
      console.error("Erreur lors de la création de l'annonce :", error.response?.data || error.message);
    } else {
      console.error("Erreur inconnue lors de la création de l'annonce :", error);
    }
    throw error;
  }
};

export const createAnnonce = async (paymentIntent: string, promoCode?: string, userId?: string, montantFinalTTC?: number) => {
  try {
    const userIdFinal = userId || localStorage.getItem('userId');
    // const token = localStorage.getItem('token');

    // if (!token) {
    //   toast.error('Token non trouvé');
    //   return;
    // }
    // if (!userIdFinal) {
    //   toast.error('Utilisateur non connecté');
    //   return;
    // }

    // const headers = {
    //   'Content-Type': 'application/json',
    //   'Authorization': `${token}`
    // };

    const response = await axios.post(`${API_URL}/annonce/creer-annonce`, {
      paymentIntent,
      // userIdInToken: userIdFinal,
      montantFinalTTC
    }, {
      // headers
    });

    // Si promoCode fourni, on applique après création effective
    if (promoCode && userIdFinal) {
      await applyPromoCode(promoCode, userIdFinal);
    }

    return response.data;
  } catch (error: any) {
    console.error('Erreur lors de la création:', error.response?.data);
    throw new Error(error.response?.data?.error || "Erreur de création");
  }
};

export const getAllAnnonceByUser = async (): Promise<Annonce[] | void> => {
  try {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      toast.error('Utilisateur non connecté');
      return;
    }

    const response = await axios.get(`${API_URL}/annonce-node/client`, {
      headers: {
        'Content-Type': 'application/json',
      },
      params: { userid: userId },
    });

    if (response.status === 200) {
      const annonceFinal: AnnonceFinal = response.data;
      return annonceFinal.annonces;
    } else {
      toast.error('Erreur lors de la récupération des annonces');
    }
  } catch (error) {
    toast.error("Erreur lors de la récupération des annonces");
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error('Une erreur inconnue s\'est produite');
    }
  }
};

export const getAnnonceByNumAnnonce = async (numAnnonce: string): Promise<Annonce | void> => {
  try {
    const response = await axios(`${API_URL}/annonce-node/num-annonce/${numAnnonce}`);
    return response.data as Annonce;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message, { cause: error.cause });
    } else if (error instanceof TypeError || error instanceof ReferenceError) {
      throw new Error(error.message);
    }
  }
};

export const getAnnonceTemp = async (paymentRef: string): Promise<any | void> => {
  try {
    const response = await axios(`${API_URL}/annonce/annonce-temp/${paymentRef}`);
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message, { cause: error.cause });
    } else if (error instanceof TypeError || error instanceof ReferenceError) {
      throw new Error(error.message);
    }
  }
};

export interface PaginatedAnnonces {
  annonces: Annonce[];
  page: number;
  perPage: number;
  totalItems: number;
  totalPages: number;
}

export const getAllAnnoncesUser = async (): Promise<Annonce[] | void> => {
  try {
    const response = await axios.get(`${API_URL}/AnnonceUser/view`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      toast.error('Erreur lors de la récupération des annonces');
    }
  } catch (error) {
    toast.error("Erreur lors de la récupération des annonces");
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    } else {
      throw new Error('Une erreur inconnue s\'est produite');
    }
  }
};


export const archiveAnnonce = async (annonceId: number): Promise<void> => {
  try {
    const response = await axios.post(`${API_URL}/annonce/archive`, {
      annonceId: annonceId,
    }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 200) {
      const { annonce } = response.data;
      toast.success(`Annonce ${annonce.numAnnonce} archivée avec succès!`);
      console.log('Détails de l\'annonce archivée:', annonce);
    } else {
      toast.error('Erreur lors de l\'archivage de l\'annonce');
    }
  } catch (error) {
    toast.error("Erreur lors de l'archivage de l'annonce");
    if (axios.isAxiosError(error) && error.response) {
      console.error('Erreur:', error.response.data);
      throw error.response.data;
    } else {
      throw new Error('Une erreur inconnue s\'est produite');
    }
  }
};

export const isUserHaveAnnonce = async (): Promise<{user_id?: number, alreadyHaveAnnonce: boolean} | void> => {
  try {
    const response = await axios.get(`${API_URL}/AnnonceUser/yet`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    });
    return response.data
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message, { cause: error.cause });
    } else if (error instanceof TypeError || error instanceof ReferenceError) {
      throw new Error(error.message);
    }
  }
}

export const getAllAnnonceTempByUser = async () => {
  const { data } = await axios.get(`${API_URL}/annonce/temp-by-user`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
  return data;
};

export const regenerateInvoice = async (annonceId: number) => {
  try {
    const response = await axios.post(
      `${API_URL}/annonce-node/${annonceId}/regenerate`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erreur lors de la régénération de la facture");
  }
};

export const previewPricing = async (annonceId: number, payload: any) => {
  try {
    const response = await axios.post(
      `${API_URL}/annonce-node/${annonceId}/pricing-preview`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erreur lors de la prévisualisation des prix");
  }
};

export const updatePricing = async (annonceId: number, payload: any) => {
  try {
    const response = await axios.put(
      `${API_URL}/annonce-node/${annonceId}/pricing`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erreur lors de la mise à jour du pricing");
  }
};

export const updateAndRegenerate = async (annonceId: number, payload: any) => {
  try {
    const response = await axios.put(
      `${API_URL}/annonce-node/${annonceId}/pricing-regenerate`,
      payload,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erreur lors de la mise à jour + régénération");
  }
};

export const updatePricingAndRegenerate = async (annonceId: number, pricingData: any, sendEmail = false) => {
  return axios.put(
    `${API_URL}/annonce-node/${annonceId}/pricing-regenerate`,
    { ...pricingData, sendEmail },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};

//Relance count increment
export const incrementAnnonceReminderCount = async (annonceId: number): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_URL}/annonce/${annonceId}/increment-reminder`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    
    console.log('✅ Compteur de relances incrémenté:', response.data);
    return response.data;
    
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('❌ Erreur incrémentation relances:', error.message);
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.error || 
        'Erreur lors de l\'incrémentation du compteur de relances.'
      );
    } else {
      console.error('❌ Erreur inattendue:', error);
      throw new Error('Erreur inattendue lors de l\'incrémentation.');
    }
  }
};